import logo from "./logo.svg";
import "./App.css";
import React, { Suspense, useEffect, useReducer, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import DefaultLayout from "./Layout/DefaultLayout";
import Login from "./Pages/LoginLayout/LoginFlowForm/Login";
import LoginLayout from "./Pages/LoginLayout/LoginLayout";
import LoginRoutes from "./Routes/LoginRoutes";
import AdminRoutes from "./Routes/AdminRoutes";
import LoginView from "./Pages/LoginFlowView/LoginView";
import SideBar from "./Components/SideBar/SideBar";
import Header from "./Components/Header/Header";
import AppContext from "./Context/AppContext";
import AppBreadcrumbs from "./Components/Widgets/BreadCrumbs";

function App() {
  const initialprops = {
    loggedin: false,
    loginInfo: {},
  };
  var li = sessionStorage.getItem("loggedIn");
  var logged = JSON.parse(sessionStorage.getItem("loginfo"));

  useEffect(() => {
    setUser({
      type: "onload",
      loggedin: li != undefined && li != "false",
      loginInfo: logged,
    });
  }, []);

  const reducer = (state, action) => {
    switch (action.type) {
      case "login":
        return {
          ...state,
          loggedin: true,
          loginInfo: { ...state.loginInfo, ...action.loginInfo },
        };
      case "logout":
        return { loggedin: false };
      case "onload":
        return {
          ...state,
          loggedin: action.loggedin,
          loginInfo: action.loginInfo,
        };
      default:
        return state;
    }
  };

  const [user, dispatch] = useReducer(reducer, initialprops);

  const setUser = (obj) => {
    dispatch(obj);
  };

 

  return (
    <AppContext.Provider value={{ user, setUser }}>
      <div className="App">
        <Router basename="/">
          {user.loggedin ? (
            <div className="app-layout">
              <SideBar className="sidebar" />
              <div className="main-sec">
                <div className="header-part">
                  <Header />
                </div>
                <div className="m-3">
              <AppBreadcrumbs />

                </div>
                <div className="app-content-sec px-3">
                  <Suspense fallback={<div>Loading...</div>}>
                    <Routes>
                      {AdminRoutes.map((route, i) => (
                        <Route
                          key={i}
                          path={route.path}
                          element={<route.Element />}
                        />
                      ))}
                    </Routes>
                  </Suspense>
                </div>
              </div>
            </div>
          ) : (
            <div className="log-flow">

              <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                  {LoginRoutes.map((data, i) => (
                    <Route
                      key={i}
                      path={data.path}
                      name={data.name}
                      element={<data.Element />}
                    />
                  ))}
                </Routes>
              </Suspense>
            </div>
          )}
        </Router>
      </div>
    </AppContext.Provider>
  );
}

export default App;
